// extracted by mini-css-extract-plugin
export default {"form":"Form_form__SQT+9","inputs":"Form_inputs__twjhH","input":"Form_input__f98at","button":"Form_button__-5oJs"};